/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiValidationStatus } from './InternalApiValidationStatus';
import {
    InternalApiValidationStatusFromJSON,
    InternalApiValidationStatusFromJSONTyped,
    InternalApiValidationStatusToJSON,
    InternalApiValidationStatusToJSONTyped,
} from './InternalApiValidationStatus';

/**
 * 
 * @export
 * @interface InternalApiBridgeSettingsFieldMapping
 */
export interface InternalApiBridgeSettingsFieldMapping {
    /**
     * 
     * @type {string}
     * @memberof InternalApiBridgeSettingsFieldMapping
     */
    fieldValue: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiBridgeSettingsFieldMapping
     */
    selectedValue: string;
    /**
     * 
     * @type {InternalApiValidationStatus}
     * @memberof InternalApiBridgeSettingsFieldMapping
     */
    validationStatus: InternalApiValidationStatus;
}

/**
 * Check if a given object implements the InternalApiBridgeSettingsFieldMapping interface.
 */
export function instanceOfInternalApiBridgeSettingsFieldMapping(value: object): value is InternalApiBridgeSettingsFieldMapping {
    if (!('fieldValue' in value) || value['fieldValue'] === undefined) return false;
    if (!('selectedValue' in value) || value['selectedValue'] === undefined) return false;
    if (!('validationStatus' in value) || value['validationStatus'] === undefined) return false;
    return true;
}

export function InternalApiBridgeSettingsFieldMappingFromJSON(json: any): InternalApiBridgeSettingsFieldMapping {
    return InternalApiBridgeSettingsFieldMappingFromJSONTyped(json, false);
}

export function InternalApiBridgeSettingsFieldMappingFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiBridgeSettingsFieldMapping {
    if (json == null) {
        return json;
    }
    return {
        
        'fieldValue': json['fieldValue'],
        'selectedValue': json['selectedValue'],
        'validationStatus': InternalApiValidationStatusFromJSON(json['validationStatus']),
    };
}

export function InternalApiBridgeSettingsFieldMappingToJSON(json: any): InternalApiBridgeSettingsFieldMapping {
    return InternalApiBridgeSettingsFieldMappingToJSONTyped(json, false);
}

export function InternalApiBridgeSettingsFieldMappingToJSONTyped(value?: InternalApiBridgeSettingsFieldMapping | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fieldValue': value['fieldValue'],
        'selectedValue': value['selectedValue'],
        'validationStatus': InternalApiValidationStatusToJSON(value['validationStatus']),
    };
}

